import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { CronEntity } from './cron.entity';
import { MessageSegmentEntity } from './message-segment.entity';

@Index('_fk__cron_idx', ['fkCronId'], {})
@Index('unique_name', ['name'], { unique: true })
@Entity('_message')
export class MessageEntity extends BaseEntity {
	@Column('varchar', { name: 'name', nullable: true, unique: true, length: 64 })
	public name!: string | null;

	@Column('datetime', { name: 'scheduledSendDate', nullable: true })
	public scheduledSendDate!: Date | null;

	@Column('text', { name: 'template', nullable: true })
	public template!: string | null;

	@Column('varchar', { name: 'returnEmail', nullable: true, length: 255 })
	public returnEmail!: string | null;

	@Column('varchar', { name: 'subject', length: 255 })
	public subject!: string;

	@Column('int', { name: '_fk__cron__id', nullable: true, unsigned: true })
	public fkCronId!: number | null;

	@Column('datetime', { name: '_started', nullable: true })
	public started!: Date | null;

	@ManyToOne(() => CronEntity, (cron) => cron.messages, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__cron__id', referencedColumnName: 'id' }])
	public fkCron!: CronEntity;

	@OneToMany(
		() => MessageSegmentEntity,
		(messageSegment) => messageSegment.fkMessage,
		{},
	)
	public messageSegments!: Array<MessageSegmentEntity>;
}
